import { Asset } from "@encoo-web/encoo-lib";
import { createModel } from "nyax";
import { createItemsEntityModel } from "src/store/itemsEntity";

export const AssetEntityModel = createModel(
  class extends createItemsEntityModel<Asset>((item) => item.id) {
    public selectors() {
      return {
        ...super.selectors(),
      };
    }
  }
);
